export function processTemplate(template, data) {
  const v = data || {}
  return template
    .replace(/\{\{mecanica oferta\}\}/g, v['mecanica oferta'])
    .replace(/\{\{nome da oferta\}\}/g, v['nome da oferta'])
    .replace(/\{\{unidade\}\}/g, v.unidade)
    .replace(/\{\{fim da validade\}\}/g, v['fim da validade'])
    .replace(/\{\{desconto da oferta\}\}/g, v['desconto da oferta'])
    .replace(/\{\{imagem da oferta\}\}/g, v['imagem da oferta'])
    .replace(/\{\{regra min max\}\}/g, v['regra min max'])
    .replace(/\{\{bestOffer\}\}/g, 'best-offer-' + (v.bestOffer || '1'))
}

export function isLargeComponent(values, isMounted, detectedSize) {
  if (values && values.templateSize && values.templateSize !== 'auto') {
    return values.templateSize === 'large'
  }

  if (isMounted && detectedSize !== null) {
    return detectedSize
  }
  return false
}

export function detectComponentSize(element) {
  const parentColumn = element.closest('.u_column, .u-column')
  if (parentColumn) {
    const parentRow = parentColumn.closest('.u_row, .u-row')
    if (parentRow) {
      const columnsInRow = parentRow.querySelectorAll('.u_column, .u-column')
      const columnCount = columnsInRow.length

      if (columnCount === 1) {
        return true
      } else if (columnCount === 2) {
        const currentColumn = parentColumn
        const columnClasses = currentColumn.className

        if (columnClasses.includes('u-col-50') || columnClasses.includes('u-col-33.33')) {
          return false
        } else if (columnClasses.includes('u-col-66.67')) {
          return true
        } else {
          return true
        }
      } else {
        return false
      }
    }
  }
  return false
}

export function notifySizeChange(onSizeChange, newSize) {
  if (onSizeChange && typeof onSizeChange === 'function') {
    onSizeChange(newSize)
  }
}
